<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="mb-0 fw-bold">{{ 'ROLE.TITLE' | translate }}</h1>
  <button class="btn btn-primary fw-bold bi-plus-lg" (click)="addNewRole()">
    {{ 'ROLE.LIST.ADD_NEW_ROLE' | translate }}
  </button>
</div>

<div class="row role-list-container">
  <div class="col">
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
        <span class="ms-2">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    } 
    @else {
      <table class="table table-hover table-striped rounded-3">
        <thead>
          <tr>
            <th scope="col">{{ 'ROLE.LIST.NAME' | translate }}</th>
            <th scope="col">{{ 'COMMON.PEOPLE' | translate }}</th>
            <th scope="col">{{ 'COMMON.CREATED_AT' | translate }}</th>
            <th scope="col">{{ 'COMMON.UPDATED_AT' | translate }}</th>
            <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (role of roles; track trackById($index, role)) {
<tr>
            <td><a [routerLink]="['/roles', role.id]" class="fw-bold">{{ role.name }}</a></td>
            <td>
              <div class="d-flex align-items-center flex-wrap gap-1">
                @if (role.peoples && role.peoples.length > 0){
                <app-avatar [personOrPeople]="role.peoples" [grouped]="true" size="normal" shape="circle" class=" border-0"></app-avatar>
                }
                @else {
                  <span class="text-muted fst-italic">{{ 'TEAM.LIST.NO_MEMBERS' | translate }}</span>
                }
              </div>
            </td>
            <td class="date-cell">
              <span
                class="d-inline-flex align-items-center small text-muted"
                [attr.title]="role.createdAt | date: 'dd MMM yyyy HH:mm'"
              >
                <i class="bi bi-calendar3 me-1"></i>
                {{ role.createdAt | date: 'dd MMM yyyy' }}
              </span>
            </td>
            <td class="date-cell">
              <span
                class="d-inline-flex align-items-center small text-muted"
                [attr.title]="role.updatedAt | date: 'dd MMM yyyy HH:mm'"
              >
                <i class="bi bi-calendar3 me-1"></i>
                {{ role.updatedAt | date: 'dd MMM yyyy' }}
              </span>
            </td>
            <td>
              <div class="btn-group" role="group">
                <button title="{{ 'COMMON.EDIT' | translate }}" class="btn btn-outline-primary btn-sm rounded-pill border-0 me-1 editRole" (click)="editRole(role)">
                  <i class="bi bi-pencil-fill"></i>
                </button>
                <button title="{{ 'COMMON.DELETE' | translate }}" class="btn btn-outline-danger btn-sm rounded-pill border-0 me-1 deleteRole" (click)="confirmDelete(role)">
                  <i class="bi bi-trash-fill"></i>
                </button>
              </div>
            </td>
          </tr>
}
        </tbody>
      </table>
    }
  </div>
</div>

<!-- Panneau latéral EN DEHORS de la row -->
<div class="sliding-panel" [class.show]="ShowForm">
  <h2>{{ roleToEdit?.id ? ('ROLE.LIST.EDIT_ROLE' | translate) : ('ROLE.LIST.ADD_NEW_ROLE' | translate) }}</h2>
  @if (roleToEdit) {
<form (ngSubmit)="onSubmit()" #roleForm="ngForm">
    <div class="mb-3">
      <label for="name" class="form-label">{{ 'ROLE.LIST.NAME' | translate }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        [(ngModel)]="roleToEdit!.name"
        name="name"
        required
        aria-required="true"
        #name="ngModel"
      />
      @if (name.invalid && name.touched) {
<div>
        {{ 'ROLE.LIST.NAME_REQUIRED' | translate }}
      </div>
}
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">{{ 'ROLE.LIST.DESCRIPTION' | translate }}</label>
      <textarea
        class="form-control"
        id="description"
        [(ngModel)]="roleToEdit!.description"
        name="description"
      ></textarea>
    </div>
    <div class="mt-3 d-flex justify-content-end">
      <button type="submit" class="btn btn-primary me-2" [disabled]="!name.valid">
        {{ roleToEdit.id ? ('ROLE.LIST.UPDATE_ROLE' | translate) : ('ROLE.LIST.CREATE_ROLE' | translate) }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </form>
}
</div>

@if (showConfirmDialog) {
<app-confirm-dialog (confirm)="handleConfirm($event)"></app-confirm-dialog>
}